module.exports = __webpack_public_path__ + "static/back-c3dd0c73d9d63586abec32756035b07e.png";